import type { Routes } from 'react-resource-router';
import { catalogRoutes } from './catalog';
import { labsRoutes } from './labs';
import { route as homeRoute } from './home';
import { assistantRoutes } from './assistant';
import { visualiserRoutes } from './visualiser';
import { queryBuilderRoutes } from './query-builder';
import { graphExplorerRoutes } from './graph-explorer';
import { cypherExplorerRoutes } from './cypher-explorer';
import { simpleGraphExplorerRoutes } from './simple-graph-explorer';
import { inferenceRoutes } from './inference';
import { inferredProjectsRoutes } from './inferred-projects';
import { graphClawHubRoutes } from './graphclaw-hub';

export const routes: Routes = [
	homeRoute,
	...catalogRoutes,
	...labsRoutes,
	...assistantRoutes,
	...visualiserRoutes,
	...queryBuilderRoutes,
	...graphExplorerRoutes,
	...cypherExplorerRoutes,
	...simpleGraphExplorerRoutes,
	...inferenceRoutes,
	...inferredProjectsRoutes,
	...graphClawHubRoutes,
] as const;
